(function() {
/* eslint-disable camelcase */
'use strict';

angular
    .module('TR')
    .factory('criteoService', criteoService);

function criteoService($q,
                       dateUtil,
                       funcUtil,
                       currentUser,
                       searchUnitService,
                       destinationAirport,
                       currentDestination,
                       broker) {
    const productTypes = {
        hotel: 1,
        tailorMade: 2,
        flight: 3
    };

    const userLanguages = {
        en: 'english',
        ar: 'arabic'
    };

    const language = TRPCONFIG.Domain.CultureCode != null
        ? userLanguages[TRPCONFIG.Domain.CultureCode.substring(0, 2)]
        : 'en';

    const service = {
        enqueue
    };

    let getCustomerIdComplete;

    broker.subscribe('criteoService', 'userExtended', function(ev) {
        if (getCustomerIdComplete) {
            getCustomerIdComplete.resolve(ev.data.UserIdHash);
        }
    });

    function _getCustomerId() {
        const user = currentUser.get();
        const isUserComplete = user && (user.Email !== undefined || !user.SignedIn);
        if (isUserComplete) {
            return $q.when(user.UserIdHash);
        }
        getCustomerIdComplete = $q.defer();
        return getCustomerIdComplete.promise;
    }

    function _getSearchDates(type) {
        const product = (type === 'hotel' ? searchUnitService.hotel : searchUnitService.flight);

        return {
            checkInDate: dateUtil.format(searchUnitService.startDate(product), 'yyyy-MM-dd'),
            checkOutDate: dateUtil.format(searchUnitService.endDate(product), 'yyyy-MM-dd')
        };
    }

    function _buildConfirmationId(items) {
        let id = '';
        if (items.hotel) {
            id += items.hotel.Details.Id;
        }
        if (items.flight && !items.hotel) {
            id += '::';
            id += searchUnitService.getDepartureAirports();
        }

        return id;
    }

    function _getIds(items, type) {
        const ids = [];

        switch (type) {
            case 'hotels':
                items = items.Hotels;
                angular.forEach(items, function(hotel) {
                    ids.push(hotel.Id);
                });
                break;
            case 'flights':
                angular.forEach(items, function(flight) {
                    ids.push(flight.FlightId);
                });
        }
        return ids;
    }

    const _config = function(type, tripType) {
        const promises = {
            customerId: _getCustomerId(),
            emailHash: (() => {
                const getEmailHash = () => currentUser.get() && currentUser.get().EmailHash;
                return type === 'bookingcomplete' ? funcUtil.waitForValue(getEmailHash) : getEmailHash();
            })()
        };
        return $q.all(promises).then(results => {
            results.customerId = results.customerId || '';
            const config = [
                { event: 'setCustomerId', id: results.customerId },
                { event: 'setAccount', account: TRPCONFIG.Domain.CriteoPartnerId },
                { event: 'setSiteType', type: (TRPCONFIG.IsMobileView) ? 'm' : 'd' }
            ];

            if (results.emailHash) {
                config.push({ event: 'setHashedEmail', m: results.emailHash, hash_method: 's2m' });
            }

            if (tripType != null) {
                switch (tripType) {
                    case 4:
                        config.push({ event: 'setData', append_to_landing_url: 'tm=1' });
                        break;
                    default:
                        config.push({ event: 'setData', append_to_landing_url: 'tm=' });
                        break;
                }
            }

            return config;
        });
    };

    function enqueue(data, type, tripType) {
        if (TRPCONFIG.Domain.isAgentMode) {
            return;
        }

        $('#criteo-tags-div').empty();

        if (TRPCONFIG.Domain.CriteoEnabled) {
            window.criteo_q = window.criteo_q || [];

            _config(type, tripType).then(function(conf) {
                let airports;
                let product;
                let title = null;

                switch (type) {
                    case 'home':
                        _homeTag(conf);
                        break;
                    case 'hotel':
                        product = {
                            dates: _getSearchDates('hotel'),
                            type: productTypes.hotel,
                            id: data.Id
                        };
                        _productTag(product, conf);
                        break;
                    case 'hotellist':
                        currentDestination.getCurrentDestination().then(function(dest) {
                            if (dest) {
                                title = dest.Title;
                            } else if (searchUnitService.getSearchArea() && data.Hotels) {
                                title = data.Hotels[0].Location;
                            }
                            product = {
                                dates: _getSearchDates('hotel'),
                                items: _getIds(data, 'hotels'),
                                type: productTypes.hotel
                            };
                            _productListTag(product, title, conf);
                        });

                        break;
                    case 'flightlist':
                        airports = searchUnitService.getDepartureAirports() || [];
                        destinationAirport.getTopEstabsForAirport(airports[0]).then(function(data) {
                            const ids = [];
                            angular.forEach(data.Hotels, function(estab) {
                                ids.push(estab.Id);
                            });

                            product = {
                                dates: _getSearchDates('flight'),
                                items: ids,
                                type: productTypes.flight
                            };
                            _productListTag(product, null, conf);
                        });
                        break;
                    case 'basket':
                        product = {
                            id: _buildConfirmationId(data.items),
                            price: data.price
                        };
                        _basketTag(product, conf);
                        break;
                    case 'bookingcomplete': {
                        const id = _buildConfirmationId(data.items);
                        if (id != null) {
                            product = {
                                id,
                                price: data.price
                            };
                            _confirmationTag(data.ref || data.ref[0], product, conf);
                        }
                        break;
                    }
                    case 'signin':
                        _signinTag(data, conf);
                }
            });
        }
    }


    function _confirmationTag(transaction, product, conf) {
        window.criteo_q.push(
            conf,
            {
                event: 'trackTransaction',
                id: transaction || transaction.id,
                item: [{
                    id: product.id,
                    price: product.price,
                    quantity: 1
                }],
                section: language
            }
        );
    }

    function _homeTag(conf) {
        window.criteo_q.push(
            conf,
            {
                event: 'viewHome',
                section: language
            }
        );
    }

    function _signinTag(data, conf) {
        window.criteo_q.push(
            conf,
            {
                event: 'setHashedEmail',
                m: data && data.EmailHash,
                hash_method: 's2m'
            }
        );
    }

    function _productTag(product, conf) {
        window.criteo_q.push(
            conf,
            { event: 'setData', user_segment: product.type },
            { event: 'viewItem', item: product.id, section: language }
        );

        if (product.dates.checkInDate || product.dates.checkOutDate) {
            window.criteo_q.push({
                event: 'viewSearch',
                checkin_date: product.dates.checkInDate,
                checkout_date: product.dates.checkOutDate
            });
        }
    }

    function _productListTag(product, keywords, conf) {
        window.criteo_q.push(
            conf,
            { event: 'setData', user_segment: product.type },
            {
                event: 'viewList',
                item: product.items,
                section: language,
                keywords
            },
            {
                event: 'viewSearch',
                checkin_date: product.dates.checkInDate,
                checkout_date: product.dates.checkOutDate
            }
        );
    }

    function _basketTag(product, conf) {
        window.criteo_q.push(
            conf,
            {
                event: 'viewBasket',
                section: language,
                retarget: 0,
                item: [{
                    id: product.id,
                    price: product.price,
                    quantity: 1
                }]
            }
        );
    }

    return service;
}
})();
